import { render, staticRenderFns } from "./select.vue?vue&type=template&id=2c77919a&scoped=true"
import script from "./select.vue?vue&type=script&lang=ts"
export * from "./select.vue?vue&type=script&lang=ts"
import style0 from "./select.vue?vue&type=style&index=0&id=2c77919a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c77919a",
  null
  
)

export default component.exports